import runner from "./app-runner";

runner();
